import * as e from "react";
import { forwardRef as l } from "react";
import { c as t } from "./index.js-Cr0Rsuyz.mjs";
function a(r, o) {
  return /* @__PURE__ */ e.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: o
  }, r), /* @__PURE__ */ e.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.187 8.687a1.15 1.15 0 0 1 1.626 0L12 13.874l5.187-5.187a1.15 1.15 0 0 1 1.626 1.626l-6 6a1.15 1.15 0 0 1-1.626 0l-6-6a1.15 1.15 0 0 1 0-1.626",
    clipRule: "evenodd"
  }));
}
var c = t(/* @__PURE__ */ l(a));
export {
  c as I
};
